import React from 'react';
import PropTypes from 'prop-types';
import ScrollableWiresList from './scrollable-wires-list';

export default function LatestWires({ contributorId, contributorName, isScrollable }) {
  return (
    <ScrollableWiresList
      contributorId={contributorId}
      contributorName={contributorName}
      isScrollable={isScrollable}
      type="latest"
    />
  );
}

LatestWires.propTypes = {
  contributorId: PropTypes.number.isRequired,
  contributorName: PropTypes.string.isRequired,
  isScrollable: PropTypes.bool,
};

LatestWires.defaultProps = {
  isScrollable: false,
};
